/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Maximages1Inputs */

const en_maximages1 = /** @type {(inputs: Maximages1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max ${i?.count} images`)
};

const de_maximages1 = /** @type {(inputs: Maximages1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max ${i?.count} Bilder`)
};

/**
* | output |
* | --- |
* | "Max {count} images" |
*
* @param {Maximages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maximages1 = /** @type {((inputs: Maximages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maximages1(inputs)
	return de_maximages1(inputs)
});
export { maximages1 as "maxImages" }